import Effects from 'Effects';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import Sample from 'repos/Sample.js';
import ethereum from 'decentralized/ethereum.js';
import sampleRateChooser from 'engine/SampleRateChooser.js';
import startaudiocontext from 'startaudiocontext';
import Tone from 'tone';
import EncryptedIpfs from 'decentralized/guilds/EncryptedIpfs.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import ipfs from 'decentralized/Ipfs.js';

const DEFAULT_NOTE = Tone.Frequency("C3");

const convolverFiles = {
    'Hangar': '/convolverHangar.wav',
    'Giant Cave': '/convolver/GiantCave.wav',
    'Airport Terminal': '/convolver/AirportTerminal.wav',
    'Outdoor Blastoff': '/convolver/OutdoorBlastOff.wav',
    'Outdoor Stadium': '/convolver/OutdoorStadium.wav',
    'Plate Large': '/convolver/PlateLarge.wav',
    'Plate Medium': '/convolver/PlateMedium.wav',
    'Plate Small': '/convolver/PlateSmall.wav',
    'Plate Super Dry': '/convolver/PlateSuperDry.wav',
    'Prime Long': '/convolver/PrimeLong.wav',
    'Prime Medium': '/convolver/PrimeMed.wav',
    'Prime Short': '/convolver/PrimeShort.wav',
    'Prime Extra Long': '/convolver/PrimeXtraLong.wav',
    'Room Concert Hall': '/convolver/RoomConcertHall.wav',
    'Room Huge': '/convolver/RoomHuge.wav',
    'Room Large': '/convolver/RoomLarge.wav',
    'Room Medium': '/convolver/RoomMedium.wav',
    'Room Pool': '/convolver/RoomPool.wav',
};

let i=0;
var convolvers = 0;
class ConvolverReverbEffect extends Effects.Effect {
    constructor(sequencerEngine, buffer=sampleRateChooser.DEFAULT_BUFFER) {
        super("Convolver Reverb", () => {
            console.log("CONSTRUCTING %s CONVOLVER", ++convolvers);
            return new Tone.Convolver(buffer);
        }, sequencerEngine);
        this.rawBuffer = new Tone.Buffer(buffer);
        // this.convolverType = 'Prime Extra Long';
        this.convolverSample = "QmcdpaZe62u6p47s2Nmi7jYLpgTbmz6MxVnwvndNFi53Sf";

        this.startParameter  = new AbstractParameter(
            'start', this, (a, b) => this.start = b, {
                defaultValue: 0,
                documentation: "Change the start point of the impulse",
                automatable: false,
            });
 
        this.pitchParameter  = new AbstractParameter(
            'Pitch', this, (a, b) => this.pitch = b, {
                documentation: "Change the pitch of the impulse",
                automatable: false,
            });
       this.durationParameter  = new AbstractParameter(
            'duration', this, (a, b) => this.release = b, {
                defaultValue: 100,
                documentation: "Change the length of the impulse",
                automatable: false,
            });
        this.attackParameter= new AbstractParameter(
            'attack', this, (a, b) => this.attack = b,
            {
                defaultValue: 0,
                documentation: "Change the attack, or fade-in, of the impulse",
                automatable: false,
            });
        this.registerParameter(this.attackParameter);
        this.registerParameter(this.startParameter);
        this.registerParameter(this.pitchParameter);
        this.registerParameter(this.durationParameter);
        this.updateInitialValues();
   }

    get documentation() {
        return [
            "Uses an impulse sample to create a realistic reverb.",
            "Drag any sample into this effect to change the impulse sample."];
    }

    set start(release) {
        if (release !== 100) {
            this.renderBuffer();
        }
    }

    set release(release) {
        if (release !== 100 && release > 0.01) {
            this.renderBuffer();
        }
    }

    set attack(attack) {
        if (attack !== 0) {
            this.renderBuffer();
        }
    }

    set pitch(pitch) {
        if (pitch === 0) {
            if (this.effectNode) {
                this.effectNode.buffer = this.rawBuffer;
            }
            return;
        }

        this.renderBuffer();
    }

    get attack() {
        return this.attackParameter.get(true);
    }

    get pitch() {
        return this.pitchParameter.get(true);
    }

    get duration() {
        return this.durationParameter.get(true);
    }

    get start() {
        return this.startParameter.get(true);
    }

    async renderBuffer() {
        if (this.rawBuffer === undefined ||
	    this.rawBuffer === null) {
	    return;
        }
        if (this.startParameter === undefined ||
            this.durationParameter === undefined ||
            this.pitchParameter === undefined) {
            return;
        }
        if (!this.effectNode) {
            return;
        }
        let buffer = new Tone.Buffer(this.rawBuffer);
        if (!this.effectNode) {
            return;
        }
        let startPoint = buffer.duration * this.start / 100.0;

        let _duration = buffer.duration - startPoint;
        if (!this.effectNode) {
            return;
        }
        let duration = _duration * this.duration / 100.0;
        let attack = duration * this.attack / 100.0;
        if (!this.effectNode) {
            return;
        }
        // otherwise we need to offline render the sample at the pitch

	this.sequencerEngine.hasConvolver = true;

        if (!this.effectNode || window.isNFT) {
            return;
        }
        // dont use tone.js offline because it fucking sucks and messes
        // with transport majorly
        let sRate = Tone.Master.context.sampleRate;
        let offlineCtx = new OfflineAudioContext(2,sRate*duration*2,sRate);
        let source = offlineCtx.createBufferSource();
        let gain = offlineCtx.createGain(1);
        gain.connect(offlineCtx.destination);
        if (attack > 0) {
            gain.gain.value = 0;
            gain.gain.linearRampToValueAtTime(1, attack);
        }
        gain.gain.linearRampToValueAtTime(0, duration);
        source.connect(gain);
        var playbackRate = Tone.intervalToFrequencyRatio(this.pitch);
        source.playbackRate.value = playbackRate;
        source.buffer = buffer._buffer;
        source.start(0, startPoint);
        let renderedBuffer = await offlineCtx.startRendering();
        let c = 0;
        while (this.effectNode === undefined) {

            await this.sleep(100);
            c++;
            if (c > 10) {
                return;
            }
        }
        this.effectNode.buffer= new Tone.Buffer(renderedBuffer);
	
   }

    sleep(ms) {
        return new Promise((resolve, reject) => {
            setTimeout(() => resolve(), ms);
        });
    }
    
    async setConvolverSample(ipfsHash) {
        if (this.encryptedIpfs === undefined) {
            this.encryptedIpfs = new EncryptedIpfs(
                this.sequencerEngine.store,
                this.sequencerEngine.ethereum.guilds,
                this.sequencerEngine.ethereum.encryption,
                this.sequencerEngine.ethereum.crypto,
            );
        }
 
        let sound = await this.encryptedIpfs.getSound(ipfsHash);
        if (sound === undefined)  {
            return;
        }
        let buffer = await Tone.Master.context.decodeAudioData(sound.buffer);
        
        if (!this.effectNode) {
            return;
        }
        this.convolverType = undefined;
        this.convolverSample = ipfsHash;

        this.rawBuffer = buffer;
        await this.renderBuffer();
    }

    setConvolverType(type) {
	return new Promise((resolve, reject) => {
            if (type in convolverFiles) {
		let fileName = window.installation ? '/public' + convolverFiles[type] :
                    convolverFiles[type];
		this.effectNode.load(fileName, async () => {
                    this.rawBuffer = new Tone.Buffer(this.effectNode.buffer);
                    await this.renderBuffer();
		    resolve();
		});
		this.samplePitch = 0;
		this.convolverType = type;
		this.convolverSample = undefined;
            }
	});
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        if (ignoreId) {
            let copy = new ConvolverReverbEffect(sequencerEngine);
            copy.fromJson(this.getJson());
            return copy;
        }
        let copy = new ConvolverReverbEffect(sequencerEngine, new Tone.Buffer(this.effectNode.buffer));
        // copy.fromJson(this.getJson(isPreset), ignoreId);
        copy.wetParameter.fromJson(this.wetParameter.getJson(), sequencerEngine);
        // copy.effectNode.buffer = this.effectNode.buffer;
        if (!ignoreId) {
            // then make sure the ids match
            copy.id = this.id;
            copy.wetParameter.id = this.wetParameter.id;
        }
        return copy;
    }

    async makePublicIfNeeded() {
        if (this.convolverSample) {
            let guildId = await ethereum.guildSamples.getGuildIdForSound(
                this.convolverSample);
            if (guildId !== undefined && guildId !== 0) {
                let sound = new Sample(this.convolverSample);
                await sound.load();
                let id = await ethereum.guildSamples.saveSample(sound);
                this.convolverSample = id;
            } 
        }
    }

    getJson(isPreset) {
        let json = {
            ... super.getJson(isPreset),
            name: this.name, 
            enabled: this.enabledParameter.get(true),
            convolverType: this.convolverType,
            convolverSample: this.convolverSample,
            start: this.start,
            pitch: this.pitch,
            attack: this.attack,
            duration: this.duration,
        };

        json = this.saveParameterToJson(json, 'wetParameter', this.wetParameter);
        return json;
    }

    async fromJson(json, isCopy=false) {
	await this.sleep(50);
        let bulk = super.fromJson(json, isCopy);
        if (json.convolverType !== undefined) {
            if (json.convolverType !== 'Prime Extra Long') {
                await this.setConvolverType(json.convolverType);
            }
        } else if (json.convolverSample !== undefined) {
            // theres some dumb ass bug where if I dont wait 10 s
            // to load the convolver sample on sequence load
            // it just straight up doesnt work (chromes fault)
	    await this.sleep(150);
            await this.setConvolverSample(json.convolverSample, json);
        }

	if ('pitch' in json) {
	    bulkUpdate(this.pitchParameter, json.pitch, bulk);
            if (json.pitch !== 0) {
                await this.sleep(50);
            }
	}

	if ('duration' in json) {
	    bulkUpdate(this.durationParameter, json.duration, bulk);
            if (json.duration !== 100) {
                await this.sleep(50);
            }
	}

	if ('attack' in json) {
	    bulkUpdate(this.attackParameter, json.attack, bulk);
	}

	if ('start' in json) {
	    bulkUpdate(this.startParameter, json.start, bulk);
	}

        return {
            ... bulk,
            // ...this.loadParameterFromJson(json, 'wetParameter', this.wetParameter, isCopy)
        };
    }

    dispose() {
        super.dispose(true);

        if (this.rawBuffer && this.rawBuffer.dispose) {
            this.rawBuffer.dispose();
        }
        this.rawBuffer = undefined;
        this.attackParameter = undefined;
        this.pitchParameter = undefined;
        this.durationParameter = undefined;
    }
}

export default ConvolverReverbEffect;
